/* eslint-disable radix */
/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import styles from "../../Components/ExportButton/ExportButton.styles";
import Button from "../../../../components/common/Button/index";
import Toast from "../../../../components/common/Toast";

const CLUSTER_FLOW_CUTOFF_DATE = new Date("2026-04-01T00:00:00");

const isClusterFlowByStartDate = (startDateValue) => {
  if (!startDateValue) return false;
  const d = new Date(startDateValue);
  if (Number.isNaN(d.getTime())) return false;
  return d.getTime() >= CLUSTER_FLOW_CUTOFF_DATE.getTime();
};

function ExportButton({ data, exportFunction }) {
  const [showToast, setShowToast] = useState(null);
  const location = useLocation();
  const handleExport = async () => {
    const queryParams = new URLSearchParams(location.search);
    try {
      const startDate = queryParams.get("startDate") || null;
      const endDate = queryParams.get("endDate") || null;

      // OLD: clusterId was always included in the download payload.
      // const payload = {
      //   areaId: queryParams.get("areaId"),
      //   clusterId: queryParams.get("clusterId") || null,
      //   zoneId: queryParams.get("zoneId") || null,
      //   regionId: queryParams.get("regionId") || null,
      //   chapterId: queryParams.get("chapterId") || null,
      //   districtId: queryParams.get("districtId") || null,
      //   blockId: queryParams.get("blockId") || null,
      //   startDate: queryParams.get("startDate") || null,
      //   endDate: queryParams.get("endDate") || null,
      // };

      const payload = {
        areaId: queryParams.get("areaId"),
        clusterId: isClusterFlowByStartDate(startDate)
          ? queryParams.get("clusterId") || null
          : null,
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        startDate,
        endDate,
      };

      const response = await exportFunction({
        data: payload,
      });
      const { name } = response.data;
      if (response.code === 200) {
        setShowToast({
          message: `${name} will be available shortly under downloads`,
          severity: "success",
        });
      }
    } catch (error) {
      setShowToast({
        message: error,
        severity: "error",
      });
    }
  };

  const disabled = !data || !data.length;

  return (
    <Box style={{ ...styles.dropdown, ...(disabled ? styles.disabled : {}) }}>
      <Box style={styles.dropdownBtn}>
        {" "}
        <Button
          variant="outlined"
          style={styles.leftSideBtn}
          onClick={handleExport}
          label="Download Reports"
          startIcon={
            <SaveAltIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
        <Box sx={styles.arrowIcon}>
          <ArrowDropDownIcon />
        </Box>
      </Box>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default ExportButton;
